import React from 'react';
import { Text } from '@blockstack/ui';
import styled from 'styled-components';
import mediaQueries from './mediaQueries';

interface Props {
    title?: string;
    marginTop?: string;
    children: React.ReactNode;
}

const CardContainer = styled.div`
    border-radius: 12px;
    box-shadow: rgba(0, 0, 0, 0.04) 0px 1px 2px;
    border: 1px solid #f0f0f5;
    padding: 24px 24px 40px 24px;
    background-color: white;
    margin-bottom: 24px;
    cursor: pointer;
    margin-top: ${(props: Props) => (props.marginTop ? props.marginTop : '')};

    @media ${mediaQueries.laptop} {
        padding: 32px 32px 40px 32px;
    }
`;

export const Stat: React.FC<Props> = ({ title, marginTop, children }: Props) => {
    return (
        <CardContainer marginTop={marginTop}>
            {title && (
                <Text as="h2" style={{ fontSize: '30px', color: '#3700ff', userSelect: 'none' }} fontWeight="bold">
                    {title}
                </Text>
            )}
            {children}
        </CardContainer>
    );
};

export default Stat;
